// Client-side Flows-catalog search predicate (FlowsPage.jsx) — normalizes
// away spacing/casing/separator differences so a human-readable query like
// "Resend Return Label" matches a flow whose flowKey is the machine-cased
// resend_return_label, without requiring the user to type underscores or
// match exact casing. Mirrors conversationSearch.js's
// matchesConversationSearch style.
function normalize(s) {
  return (s ?? '').toLowerCase().replace(/[\s_-]+/g, '')
}

export function matchesFlowSearch(flow, query) {
  const q = normalize(query)
  if (!q) return true
  return normalize(flow.flowKey).includes(q) || normalize(flow.displayName).includes(q)
}
